<template>
    <div class="unit-info-prometheus show-info"
         :class="[!isSectionInfoOpen && 'show-info--close']"
    >
        <button class="button button-close button-close-info"
                :class="[!isSectionInfoOpen && 'button-close-info']"
                @click="toggleList"
        >
            <SvgIcon :name="buttonToggleIcon" class="icon"/>
        </button>

        <component :is="componentBlockInfo" :unitId="unitId" v-show="isSectionInfoOpen"></component>

    </div>

    <router-view :class="$attrs.class"></router-view>

    <Teleport to="#sectionInfoByPage" :key="componentBlockInfo">
        <router-view name="info"></router-view>
    </Teleport>

    <Teleport to="#sectionInfoByRoute">
        <router-view :class="$attrs.class" name="sectionInfoByRoute" v-on:close-dialog="onCloseSectionInfoByRoute"></router-view>
    </Teleport>
</template>

<script>
import UnitInfo_content_reefer from '@/components/units/pageInfo/info-block/UnitInfo_content_reefer.vue';
import UnitInfo_content_base from '@/components/units/pageInfo/info-block/UnitInfo_content_base.vue';
import unitMixin from "@/mixins/unitMixin";
import {mapGetters} from "vuex";

export default {
    name: "UnitInfo",
    inject: ['fnAddPageClass', 'fnRemovePageClass'],
    mixins: [unitMixin],
    props: {
        unitId: Number,
    },
    data() {
        return {
            isSectionInfoOpen: true,
        }
    },
    components: {
        UnitInfo_content_base,
        UnitInfo_content_reefer,
    },
    computed: {
        ...mapGetters([
            "getWindowWidth",
        ]),
        componentBlockInfo() {
            return this.routeMeta.componentBlockInfo || 'UnitInfo_content_base';
        },
        watchSectionInfoOpen() {
            return [this.routeName, this.unitId, this.getWindowWidth].join(';')
        },
        hideInfoUnit() {
            return !!this.routeMeta?.hideInfoUnit
        },
        buttonToggleIcon() {
            return this.isSectionInfoOpen ? 'double-arrow-left' : 'double-arrow-right';
        },
    },
    watch: {
        watchSectionInfoOpen: {
            handler: function () {
                this.updateSectionInfoOpen()
            },
        },
    },
    methods: {
        onCloseSectionInfoByRoute(){
            this.setRoute.returnToParent(this.$route, this.$router)
        },
        toggleList() {
            this.isSectionInfoOpen = !this.isSectionInfoOpen
            if(this.isSectionInfoOpen) {
                this.fnAddPageClass('open-info')
            } else {
                this.fnRemovePageClass('open-info')
            }
            // this.setRoute.unitId(this.$route, this.$router, this.unitId)
        },
        updateSectionInfoOpen() {
            this.isSectionInfoOpen = (this.getWindowWidth <= 1700 && this.mainRouteName != this.$consts.routerNames?.units?.xroute?.main) ? false : !this.hideInfoUnit
            if(!this.isSectionInfoOpen) {
                this.fnRemovePageClass('open-info')
            } else {
                this.fnAddPageClass('open-info')
            }

        }
    },
    created() {
        this.updateSectionInfoOpen();
    },
    mounted() {
    },
    beforeUnmount() {
        this.fnRemovePageClass('open-info')
    }
}
</script>

<style lang="scss" scoped>
.unit-info-prometheus {
    .button-close {
        left: 100%;
        top: 6px;
        right: auto;
        z-index: 10000;
        width: 25px;
        height: 45px;

        .icon {
            width: 80%;
        }
    }
}
</style>